/* Vistos recientemente, basado en localStorage. No requiere cuenta ni apps de pago.
   Guarda los "handles" de los productos que el visitante ha ido abriendo y, al final
   de cada ficha de producto, muestra los últimos vistos (menos el que se está viendo)
   con datos reales obtenidos vía /products/{handle}.js. */
(function () {
  var STORAGE_KEY = 'mt_recently_viewed';
  var MAX_STORED = 12;
  var MAX_SHOWN = 8;

  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage no disponible (modo privado, etc.) - fallamos en silencio */
    }
  }

  function remember(handle) {
    if (!handle) return;
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx !== -1) list.splice(idx, 1);
    list.unshift(handle);
    if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
    saveList(list);
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function resize(url) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?width=500' : '&width=500');
  }

  function renderSection(section) {
    var currentHandle = section.getAttribute('data-current-handle');
    var track = section.querySelector('.mt-recently-viewed__track');
    if (!track) return;

    var list = getList()
      .filter(function (handle) {
        return handle !== currentHandle;
      })
      .slice(0, MAX_SHOWN);

    if (!list.length) {
      section.hidden = true;
      return;
    }

    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      track.innerHTML = '';
      var any = false;
      products.forEach(function (p, i) {
        if (!p) return;
        any = true;
        var handle = list[i];
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var card = document.createElement('a');
        card.href = '/products/' + handle;
        card.className = 'mt-recently-viewed__card';
        card.innerHTML =
          '<span class="mt-recently-viewed__media">' +
          (img ? '<img src="' + resize(img) + '" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span class="mt-recently-viewed__title">' + p.title + '</span>' +
          '<span class="mt-recently-viewed__price">' + formatMoney(p.price) + '</span>';
        track.appendChild(card);
      });
      section.hidden = !any;
    });
  }

  function init() {
    var sections = document.querySelectorAll('.mt-recently-viewed');
    if (!sections.length) return;
    sections.forEach(function (section) {
      remember(section.getAttribute('data-current-handle'));
      renderSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
